import { render, staticRenderFns } from "./SimpleTextContent.vue?vue&type=template&id=0c8decdc&scoped=true"
import script from "./SimpleTextContent.vue?vue&type=script&lang=js"
export * from "./SimpleTextContent.vue?vue&type=script&lang=js"
import style0 from "./SimpleTextContent.vue?vue&type=style&index=0&id=0c8decdc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8decdc",
  null
  
)

export default component.exports